
let language = {
    HINT_MODAL_HINT_TITLE: "提示",

    HINT_MODAL_DUPLICATE_FILE_NAME_TIP: "文件名重复，文件名已重命名为：",

    HINT_MODAL_OK_BTN: "确认",
};

export { language }